<mat-nav-list [ngClass]="{ collapsed: isCollapsed() }">
  @for (navItem of mainNavItems; track navItem) {
  <a
    class="num-mat-list-item"
    [routerLinkActive]="'num-mat-list-item--active'"
    mat-list-item
    [disableRipple]="true"
    [routerLink]="navItem.routeTo"
    (click)="menuItemClicked($event, navItem)"
    [matTooltip]="isCollapsed() ? (navItem.translationKey | translate) : null"
    matTooltipPosition="right"
  >
    @if (navItem.icon) {
    <fa-icon size="lg" [fixedWidth]="true" [icon]="navItem.icon"></fa-icon>
    } @if (navItem.svgIcon) {
    <mat-icon class="nav-svg-icon" [svgIcon]="navItem.svgIcon"></mat-icon>
    } @if (isSideMenuExpanded()) {
    <div class="navItem-font">
      {{ navItem.translationKey | translate }}
    </div>
    }
  </a>
  }

  <div class="num-logo-row">
    <button
      type="button"
      [attr.aria-label]="'APPLAYOUT.TOGGLE.LABEL' | translate"
      mat-icon-button
      (click)="toggleMenu()"
    >
      @if (isSideMenuExpanded()) {
      <fa-icon size="1x" icon="angle-double-left"></fa-icon>
      } @if (isCollapsed()) {
      <fa-icon size="1x" icon="angle-double-right"></fa-icon>
      }
    </button>
  </div>
</mat-nav-list>
